<template>
  <div id="samyan-coop-content" class="samyan-coop-content">
    <div id="error-page" class="coop-page error-page">
      <div class="page-bg" />
      <div class="container text-center">
        <h1
          v-if="error.statusCode === 404"
        >
          Page not found
        </h1>
        <h1
          v-else
        >
          An error occurred
        </h1>
        <h2>
          {{ error.message }}
        </h2>
        <p>
          Go to:
          <nuxt-link
            to="/"
          >
            Home page
          </nuxt-link>
        </p>
      </div>
    </div>
    <!-- Matomo -->
    <script type="text/javascript">
      var _paq = window._paq || [];
      /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
      var u="//samyancoop.samyan-mitrtown.com/analytics/";
      _paq.push(['setTrackerUrl', u+'matomo.php']);
      _paq.push(['setSiteId', '1']);
      var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
      g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'matomo.js'; s.parentNode.insertBefore(g,s);
      })();
    </script>
    <!-- End Matomo Code -->
  </div>
</template>

<script>
export default {
  name: 'NuxtErrorPage',
  props: {
    error: {
      type: Object,
      default: () => {}
    }
  },
  mounted () {
    console.error('error page', this.error)
    if (this.$sentry) {
      this.$sentry.captureException(this.error)
    }
  }
}
</script>

<style>
</style>
